import React, { useState, useEffect } from 'react';

interface TimerProps {
    startTime: string | null;
    durationMinutes: number;
    onTimeUp: () => void;
}

const Timer: React.FC<TimerProps> = ({ startTime, durationMinutes, onTimeUp }) => {
    const [remaining, setRemaining] = useState("00:00");

    useEffect(() => {
        if (!startTime) return;

        const interval = setInterval(() => {
            const start = new Date(startTime).getTime();
            const now = new Date().getTime();
            const elapsed = Math.floor((now - start) / 1000);
            const totalDuration = durationMinutes * 60;
            const timeLeft = totalDuration - elapsed;

            if (timeLeft <= 0) {
                setRemaining("00:00");
                clearInterval(interval);
                onTimeUp();
                return;
            }

            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;
            setRemaining(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);

        }, 1000);

        return () => clearInterval(interval);
    }, [startTime, durationMinutes, onTimeUp]);

    return <div>Tiempo restante: <strong>{remaining}</strong></div>;
};

export default Timer;